<template>
  <div class="wapper">
    <el-container style="100%">
      <Meeting @getDocumentTypeId="getDocumentTypeId"></Meeting>
      <el-main style="background: #fff; margin-left: 10px">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">

            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column prop="code" label="证件类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.type }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="会议名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="logo" label="场馆" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.hall }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="开始结束日期"
                               width="180" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.startDate }}</p>
                  <p>{{ scope.row.endDate }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="可入人数" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.total }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="已入人数" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.count }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditMeetingDocumentType
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditMeetingDocumentType>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditMeetingDocumentType from "../../../components/ticketing/meeting/EditMeetingDocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";
import Meeting from "@/components/ticketing/meeting/meeting";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      totalPage: 0,
      dataList: [],
      arrayList: [],
      multipleSelection: [],
      listShow: true,
      delVisible: false,
      editShow: false,
      editData: {},
      searchForm: {
        name: "",
      },
      type: 0,
      meetingDocumentTypeId: "",
      projectId: localStorage.getItem("project_Id"),
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getDocumentTypeId(val) {
      this.type = val;
      this.searchForm.type = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleCloseVisible() {
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCopy(index, row) {
      if (confirm("是否拷贝行")) {
        let data = JSON.parse(JSON.stringify(row));
        data.meetingDocumentTypeId = null;
        data.name += "-拷贝"
        this.$axios.post(`/MeetingDocumentType/`, data).then((res) => {
          if (res.data.hasError) {
            this.$message.error(res.data.message);
          } else {
            this.$message.success("新增成功！");
            this.getData();
          }
        });
      }
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.meetingDocumentTypeId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        type: this.type,
      };
      this.$axios.post("/MeetingDocumentType/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    deleteData() {
      this.$axios
          .delete(`/MeetingDocumentType/${this.meetingDocumentTypeId}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.meetingDocumentTypeId = row.meetingDocumentTypeId;
      this.delVisible = true;
    },
  },
  components: {
    EditMeetingDocumentType,
    Meeting,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.el-main {
  border-radius: 5px;
  position: relative;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;

  .btn-r {
    margin-right: 20px;
  }
}

.pag {
  position: absolute;
  bottom: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.el-dialog {
  height: auto;
}
</style>